<template lang="pug">
#report
  .box
    .box-body
      b-tabs(v-model="tabIndex")
        //- calendar tab
        b-tab.tab
          template(v-slot:title)
            .tab-title
              span.mr-1 カレンダー
              .refresh-icon(@click.stop="refreshCalendar" title="再読み込みします")
          CalendarTab(ref="calendarTab")
        //- export report tab
        b-tab.tab(v-if="_useFamilyService && _isOverLightPlan" title="活動履歴出力")
          ExportReportTab(ref="exportReportTab")
</template>

<script lang="ts">
import { Component, Ref, Vue } from "vue-property-decorator";
import { Route } from "vue-router";

import { userStore } from "@/store/store";
import { PlanType } from "@/commons/services/Plans";

import CalendarTab from "@/pc/containers/reports/CalendarTab.vue";
import ExportReportTab from "@/pc/containers/reports/ExportReportTab.vue";

/** ナビゲーションガードのフックを使えるようにする */
Component.registerHooks(["beforeRouteLeave"]);

/**
 * ### 活動予定・履歴コンポーネント
 */
@Component({
  components: {
    CalendarTab,
    ExportReportTab
  },
  name: "Report"
})
export default class Report extends Vue {
  /** タブインデックス(0始まり) */
  tabIndex: number = 0;

  @Ref()
  calendarTab!: CalendarTab;

  get _useFamilyService(): boolean {
    return userStore.facility.useFamilyService;
  }

  /** ### プランがライト以上かを返す */
  get _isOverLightPlan(): boolean {
    const planType: PlanType = userStore.facility.planType;

    if (PlanType.LIGHT <= planType) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * ### カレンダータブの画面表示を更新する
   */
  public async refreshCalendar(): Promise<void> {
    await this.calendarTab.refresh();
    return;
  }

  beforeRouteLeave(to: Route, from: Route, next: Function) {
    // 画面を離れる前に現在のフィルタリング条件をVuexに保存
    if (this.$options.name) {
      this.calendarTab.setFilterSetting();
    }
    next();
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";

#report {
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;

  .box-body {
    .spinner {
      width: 16px;
      height: 16px;
      color: $loading;
    }
    .refresh-icon {
      @include svg-icon("../../../assets/refresh.svg", $font-base-color, 20px, 20px);
      opacity: 0.5;
      text-shadow: 0 1px 0 #fff;
      cursor: pointer;
    }
    .refresh-icon:hover {
      opacity: 0.75;
    }
  }
}
</style>
